// src/components/BottomNav.jsx
import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import "./BottomNav.css";

const BottomNav = () => {
  const location = useLocation();
  const navigate = useNavigate();

  return (
    <div className="bottom-nav">
      {/* HOME */}
      <div
        className={`nav-item ${location.pathname === "/" ? "active" : ""}`}
        onClick={() => navigate("/")}
      >
        <i className="bi bi-house-fill nav-icon"></i>
        <span>Home</span>
      </div>

      {/* PROFILE */}
      <div
        className={`nav-item ${
          location.pathname === "/profile" ? "active" : ""
        }`}
        onClick={() => navigate("/profile")}
      >
        <i className="bi bi-person-circle nav-icon"></i>
        <span>Profile</span>
      </div>
    </div>
  );
};

export default BottomNav;
